import { render, staticRenderFns } from "./NewCall.vue?vue&type=template&id=5afbaee2&scoped=true&"
import script from "./NewCall.vue?vue&type=script&lang=js&"
export * from "./NewCall.vue?vue&type=script&lang=js&"
import style0 from "./NewCall.vue?vue&type=style&index=0&id=5afbaee2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afbaee2",
  null
  
)

export default component.exports